import type { ReactElement } from 'react';

import BpkButton, { BUTTON_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';
import { withButtonAlignment } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkMinusIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/minus';
import BpkPlusIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/plus';

import STYLES from './FooterLinkToggle.module.scss';

type Props = {
  altText: string;
  expanded: boolean;
  hidden: boolean;
  onClick: () => void;
};
const AlignedPlusIcon = withButtonAlignment(BpkPlusIcon);
const AlignedMinusIcon = withButtonAlignment(BpkMinusIcon);

const FooterLinkToggle = (props: Props): ReactElement => {
  const Icon = props.expanded ? AlignedMinusIcon : AlignedPlusIcon;
  return (
    <BpkButton
      type={BUTTON_TYPES.linkOnDark}
      alt={props.altText}
      aria-label={props.altText}
      aria-hidden={props.hidden}
      className={STYLES['footer-link-toggle__link']}
      onClick={props.onClick}
      tabIndex={props.hidden ? '-1' : ''}
      iconOnly
    >
      <Icon className={STYLES['footer-link-toggle__icon']} />
    </BpkButton>
  );
};

export default FooterLinkToggle;
